/*******************************************************************************************/
/*  작 성 자 : 바이크뱅크(주)
/*  작 성 일 : 2023.05.04
/*  수 정 일 : 2023.
/*  버     전 : 0.0.1
/*  설     명 : 로딩 스피너
/*  위     치 : src/components/Spinner.jsx
/*******************************************************************************************/
import React from 'react'
import { RotatingLines } from 'react-loader-spinner'

import './Spinner.scss'

const Spinner = () => {
    return (
        <div className="spinner-wrap">
            <RotatingLines strokeColor="#8fc31f" strokeWidth="5" animationDuration="0.75" width="96" visible={true} />
        </div>
    )
}

export default Spinner
